import { useMemo } from 'react'
import { type Image } from '@utils/cook/types'

import useSportEntitySubscriptions from '@hooks/useSportEntitySubscriptions'
import useSportEntities from '@hooks/useSportEntities'

import FollowMyTeamOverviewWithSubscriptions from './FollowMyTeamOverviewWithSubscriptions'
import FollowMyTeamOverviewBanner from './FollowMyTeamOverviewBanner'

interface FollowMyTeamOverviewAPIProps {
  backgroundImage: Image<'16_9'>
  image: Image<'free'>
  title: string
  onBannerClick: () => void
  onSettingsClick: () => void
  onAddTeamClick: () => void
}

const FollowMyTeamOverview = ({
  backgroundImage,
  image,
  title,
  onBannerClick,
  onSettingsClick,
  onAddTeamClick,
}: FollowMyTeamOverviewAPIProps) => {
  const { getSportEntityById } = useSportEntities()

  const { data, isSuccess: isEntitySubscriptionsSuccess } =
    useSportEntitySubscriptions({
      entityType: 'competitor',
    })

  const sportEntitySubscriptions = useMemo(
    () =>
      data?.map((entitySubscription) => ({
        ...entitySubscription,
        ...(getSportEntityById(entitySubscription.entityId) ?? {}),
      })) ?? [],
    [data, getSportEntityById]
  )

  const hasSportEntitySubscriptions = sportEntitySubscriptions?.length

  return isEntitySubscriptionsSuccess ? (
    hasSportEntitySubscriptions ? (
      <FollowMyTeamOverviewWithSubscriptions
        sportEntitySubscriptions={sportEntitySubscriptions}
        onAddTeamClick={onAddTeamClick}
        onSettingsClick={onSettingsClick}
      />
    ) : (
      <FollowMyTeamOverviewBanner
        backgroundImage={backgroundImage}
        image={image}
        title={title}
        onClick={onBannerClick}
      />
    )
  ) : null
}

export default FollowMyTeamOverview
